import Jwt from '../../../helper/interceptors';
import { AppSettings } from '../../../constants';
import { MapResponse } from '../../../helper/helper-api';

export const getMaintenanceSettings = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`api/maintenance-schedule-settings/${params.projectId}`)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const putMaintenanceSettings = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .put(`api/maintenance-schedule-settings/${params.projectId}`, params)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const getTimeZoneList = () => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get('api/maintenance-schedule-common-settings/get-list-select-time-zone')
    .then(response => {

      return MapResponse(response);
    })
    .catch(error => { return MapResponse(error.response); });
};

export const postGeneralTask = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('api/maintenance-schedule-generals', params)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const putGeneralTask = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .put(`api/maintenance-schedule-generals/${params.id}`, params)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const getGeneralTask = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`api/maintenance-schedule-generals/${params.id}?projectId=${params.projectId}`)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const postSpecificTask = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post('api/maintenance-schedule-inventory-specifics', params)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const putSpecificTask = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .put(`api/maintenance-schedule-inventory-specifics/${params.id}`, params)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const getSpecificTask = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`api/maintenance-schedule-inventory-specifics/${params.id}?inventoryItemId=${params.inventoryItemId}&projectId=${params.projectId}`, params)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const getLotList = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`api/maintenance-schedule-generals/get-lots-to-pick?projectId=${params.projectId}`)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const getTaskList = (params) => {
  const uri = params.taskType === 0
    ? `api/maintenance-schedule-generals?projectId=${params.projectId}`
    : `api/maintenance-schedule-inventory-specifics?projectId=${params.projectId}`;

  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(uri)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const getTaskReminderList = (params) => {
  const uri = `api/maintenance-schedule-reminders?projectId=${params.projectId}&from=${encodeURIComponent(params.fromDate)}&to=${encodeURIComponent(params.toDate)}`;

  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(uri)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const removeTask = (params) => {
  let uri = params.isGeneralTask ? 'api/maintenance-schedule-generals' : 'api/maintenance-schedule-inventory-specifics';

  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .delete(`${uri}/${params.id}`)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const getSuggestedGeneralTask = (params) => {
  let uri = `api/maintenance-schedule-template-generals?projectId=${params.projectId}`;

  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`${uri}`)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const getSuggestedSpecificTask = (params) => {
  let uri = `api/maintenance-schedule-template-inventory-specifics?projectId=${params.projectId}`;

  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .get(`${uri}`)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};

export const postSuggestedGeneralTask = (params) => {
  let uri = 'api/maintenance-schedule-template-generals/import';

  return Jwt(AppSettings.CURRENT_SITE_URI, true)
    .post(uri, params)
    .then(response => { return MapResponse(response); })
    .catch(error => { return MapResponse(error.response); });
};



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/api.js